import { useLocation } from "react-router-dom";

export type Lang = "fr" | "es";

type Dict = Record<string, string>;

const fr: Dict = {
  // Header
  "header.discuter": "Discuter",
  "header.discuter_aria": "Discuter avec Célia",
  "header.demande_short": "Demande",
  "header.envoyer_demande": "Envoyer ma demande",
  "header.plateforme_short": "Plateforme",
  "header.plateforme_full": "Accéder à la plateforme Bostik - Arkema",
  "header.pill_role": ", votre conseillère ",

  // Helmet
  "seo.title": "Naboo × Bostik - Arkema — Plateforme événementielle dédiée aux collaborateurs Bostik - Arkema",
  "seo.description": "Plateforme Naboo réservée exclusivement aux collaborateurs Bostik - Arkema : organisez vos séminaires, événements et team building avec des conditions négociées et un accompagnement dédié par Célia.",
  "seo.og.description": "Espace privé Bostik - Arkema × Naboo : organisez vos séminaires et événements d'entreprise avec tarifs négociés et accompagnement dédié. Réservé aux équipes Bostik - Arkema.",
  "seo.og.image_alt": "Logos Bostik - Arkema et Naboo — Votre plateforme événementielle dédiée",
  "seo.twitter.title": "Naboo × Bostik - Arkema — Plateforme événementielle dédiée",
  "seo.twitter.description": "Espace privé Bostik - Arkema × Naboo : séminaires, événements et team building avec tarifs négociés et conseillère dédiée. Réservé aux collaborateurs Bostik - Arkema.",
  "seo.twitter.image_alt": "Naboo × Bostik - Arkema — Plateforme événementielle dédiée",
  "seo.author": "Naboo pour Bostik - Arkema",
  "seo.locale": "fr_FR",
  "html.lang": "fr",

  // Hero
  "hero.badge": "Quiz",
  "hero.title": "Quelques questions rapides pour trouver votre lieu idéal.",
  "hero.step.type": "Type d'événement",
  "hero.step.dates": "Dates",
  "hero.step.participants": "Participants",
  "hero.step.match": "Votre match",
  "hero.cta": "Démarrer →",
  "hero.subline": "Résultats en moins de 30 sec",

  // Stats
  "stats.partnership_value": "2 ans",
  "stats.partnership": "Partenariat",
  "stats.events": "Événements organisés",
  "stats.participants": "Participants",
  "stats.colleagues": "Collègues inscrits",

  // Colleagues section
  "colleagues.title": "Déjà 226 collègues Bostik - Arkema sont inscrits sur Naboo",
  "colleagues.paragraph": "Retrouvez l'historique de vos événements, le suivi de vos projets en cours et tous vos devis au même endroit.",
  "colleagues.cta": "Créer un compte →",
  "colleagues.label": "Vos collègues utilisent déjà Naboo",
  "colleagues.more": "collègues",

  // Top destinations
  "destinations.title": "Top destinations",
  "destinations.instant": "Réservation instantanée",
  "destinations.bottom_title": "Découvrez plus de 50 000 lieux et prestataires dans notre base de données",
  "destinations.bottom_subtitle": "Explorez l'ensemble du catalogue Naboo réservé aux équipes Bostik - Arkema.",
  "destinations.bottom_cta": "Explorer les lieux →",

  // Floating push
  "push.line1": "Votre lieu idéal en 30s",
  "push.line2": "Quiz Naboo",
  "push.close": "Fermer",

  // Event types
  "events.title": "Organisez tout type d'événement, de 5 à 500 participants, partout dans le monde",
  "events.prev": "Précédent",
  "events.next": "Suivant",
  "events.go_to": "Aller à l'événement",
  "events.stay": "Séjour avec nuitée",
  "events.conf": "Conférences",
  "events.rooms": "Réservation de chambres pour expositions et salons",
  "events.awayday": "Journée externe | Réunion | Session de formation",
  "events.parties": "Soirées d'entreprise | Afterworks",
  "events.meals": "Repas d'affaires | Traiteur",
  "events.tb": "Activité team building",

  // Services
  "services.title": "Une seule plateforme pour toute votre logistique",
  "services.paragraph": "De la salle de réunion au bus de transfert, on s'occupe de tout. Vous n'avez qu'un seul interlocuteur : Célia.",
  "services.catering": "Restauration & traiteurs",
  "services.animation": "Animation & speakers",
  "services.transport": "Transport & transferts",
  "services.hotels": "Hôtels & lieux",
  "services.coworking": "Salles & coworking",
  "services.more": "+ tout autre service événementiel sur demande",

  // Preferred terms
  "pt.title": "Bénéficiez de conditions préférentielles",
  "pt.col.invoicing": "Portage de factures",
  "pt.col.standard": "Service Standard",
  "pt.col.turnkey": "Service Clé en Main",
  "pt.group.admin": "Admin",
  "pt.group.search": "Recherche de lieu",
  "pt.group.management": "Gestion d'événement",
  "pt.row.fees": "Frais",
  "pt.row.advance": "Avance d'acompte",
  "pt.row.referencing": "Référencement de nouveaux lieux et prestataires via Naboo",
  "pt.row.autonomy": "Autonomie complète sur la plateforme",
  "pt.row.delegation": "Délégation du brief à un expert événementiel avec suggestions et support illimités",
  "pt.row.assistance": "Assistance illimitée pour négocier les prix et conditions",
  "pt.row.app": "Application événementielle pour organisateurs et participants",
  "pt.row.visit": "Visite du site",
  "pt.row.coordination": "Coordination des prestataires après signature du devis",
  "pt.row.onsite": "Gestionnaire d'événement sur place pendant l'événement (>40K€)",
  "pt.discover_fees": "Découvrez nos frais",
  "pt.cta": "Découvrir la plateforme Bostik - Arkema",

  // How to
  "how.badge": "En 6 étapes simples",
  "how.title": "Comment faire ?",
  "how.step": "Étape",
  "how.of": "/",
  "how.prev": "Étape précédente",
  "how.next": "Étape suivante",
  "how.go_to": "Aller à l'étape",
  "how.s1.title": "Envoyez votre brief",
  "how.s1.desc": "Envoyez votre brief à votre expert événementiel (via la plateforme, par email ou par téléphone) ou recherchez en utilisant la barre de recherche en toute autonomie.",
  "how.s1.link.platform": "Lien vers la plateforme",
  "how.s2.title": "Obtenez une réponse rapide",
  "how.s2.desc": "Votre expert événementiel répond dans l'heure, fait les premières suggestions dans les 2 heures et finalise vos devis dans les 2 jours.",
  "how.s3.title": "Demandez des ajustements",
  "how.s3.desc": "Demandez des ajustements ou de nouvelles propositions. Votre expert met tout à jour dans les 24 heures jusqu'à ce que vous soyez prêt à confirmer votre réservation. Les ajustements sont illimités.",
  "how.s4.title": "Confirmez la réservation",
  "how.s4.desc": "Quand vous êtes satisfait de vos devis, téléchargez le devis qui correspond à vos attentes et lancez votre processus de demande d'achat.",
  "how.s5.title": "Créez votre demande d'achat",
  "how.s5.desc": "Pendant la validation de votre demande d'achat, cliquez sur 'Confirmer la réservation' sur la plateforme pour télécharger la facture finale et transformer votre demande d'achat en bon de commande. Pas de souci pour le paiement, Naboo s'occupe de tout.",
  "how.s6.title": "Obtenez un support complet (optionnel)",
  "how.s6.desc": "Si vous avez besoin d'aide pour organiser votre événement, Naboo peut vous fournir un support complet de gestionnaire d'événement jusqu'au jour de l'événement, il suffit de demander !",

  // Footer
  "footer.terms": "Conditions générales d'utilisation",
  "footer.cgu": "CGU",
  "footer.contact": "Contactez-nous",
  "footer.cookies": "Modifier vos préférences de cookies",
  "footer.linkedin": "LinkedIn",
  "footer.instagram": "Instagram",
  "footer.email": "Email",

  // Ombeline / Célia popover
  "pop.subject": "Demande Bostik - Arkema",
  "pop.copy": "Copier l'email",
  "pop.gmail": "Ouvrir dans Gmail",
  "pop.outlook": "Ouvrir dans Outlook",
  "pop.mail_app": "Utiliser mon application mail",
  "pop.copied": "Email copié",
  "pop.copy_error": "Impossible de copier",

  // Lang switcher
  "lang.fr": "FR",
  "lang.es": "ES",

  // Quiz modal — steps
  "quiz.step.type": "Type",
  "quiz.step.dates": "Dates",
  "quiz.step.categories": "Catégories",
  "quiz.step.participants": "Participants",
  "quiz.step.standing": "Standing",
  "quiz.step.match": "Votre match",
  "quiz.match_suffix": "% match",
  "quiz.title.type": "Quel type d'événement organisez-vous ?",
  "quiz.title.dates_prefix": "Quand souhaitez-vous organiser votre ",
  "quiz.title.dates_suffix": " ?",
  "quiz.title.event_word": "événement",
  "quiz.title.categories": "Quel type de destination recherchez-vous ?",
  "quiz.title.participants": "Quelle est la taille de votre groupe ?",
  "quiz.title.standing": "Quel standing souhaitez-vous ?",
  "quiz.label.0": "Étape 1/6 — C'est parti !",
  "quiz.label.1": "Étape 2/6 — Vous êtes sur la bonne voie !",
  "quiz.label.2": "Étape 3/6 — On avance bien !",
  "quiz.label.3": "Étape 4/6 — Plus que 2 étapes !",
  "quiz.label.4": "Étape 5/6 — On y est presque !",
  "quiz.label.5": "Étape 6/6 — Dernière ligne droite !",

  // Quiz event types
  "quiz.evt.seminaire": "Séminaire d'entreprise",
  "quiz.evt.journee_hors_site": "Journée hors site",
  "quiz.evt.soiree": "Soirée d'entreprise",
  "quiz.evt.team_building": "Activité team building",
  "quiz.evt.conference": "Conférence",
  "quiz.evt.lancement_produit": "Lancement de produit",
  "quiz.evt.autre": "Autre",
  "quiz.evt.placeholder": "Votre événement…",

  // Quiz dates
  "quiz.dates.placeholder": "Sélectionner une date ou période",
  "quiz.dates.or_month": "Ou sélectionnez un mois :",
  "quiz.month.0": "Janvier",
  "quiz.month.1": "Février",
  "quiz.month.2": "Mars",
  "quiz.month.3": "Avril",
  "quiz.month.4": "Mai",
  "quiz.month.5": "Juin",
  "quiz.month.6": "Juillet",
  "quiz.month.7": "Août",
  "quiz.month.8": "Septembre",
  "quiz.month.9": "Octobre",
  "quiz.month.10": "Novembre",
  "quiz.month.11": "Décembre",

  // Quiz categories
  "quiz.cat.Plage": "Plage",
  "quiz.cat.Montagne": "Montagne",
  "quiz.cat.Ville": "Ville",
  "quiz.cat.Nature": "Nature",
  "quiz.cat.Désert": "Désert",
  "quiz.cat.Tropical": "Tropical",
  "quiz.cat.Bord de lac": "Bord de lac",
  "quiz.cat.Île": "Île",
  "quiz.cat.Historique": "Historique",
  "quiz.cat.Luxe": "Luxe",
  "quiz.cat.Aventure": "Aventure",
  "quiz.cat.Bien-être": "Bien-être",

  // Quiz participants
  "quiz.tier.Petit comité": "Petit comité",
  "quiz.tier.Groupe convivial": "Groupe convivial",
  "quiz.tier.Grande équipe": "Grande équipe",
  "quiz.tier.Grand événement": "Grand événement",
  "quiz.tier.Événement XL": "Événement XL",
  "quiz.participants.hint": "Entrez le nombre de participants",
  "quiz.participants.placeholder": "Ex : 45",

  // Quiz standing
  "quiz.standing.Essentiel": "Essentiel",
  "quiz.standing.Confort": "Confort",
  "quiz.standing.Premium": "Premium",
  "quiz.standing.Prestige": "Prestige",
  "quiz.standing.Exception": "Exception",

  // Quiz budget
  "quiz.budget.per_person": "soit {p} € / personne",
  "quiz.budget.or": "OU",
  "quiz.budget.exact": "Indiquer un montant exact",
  "quiz.budget.placeholder": "Ex : 25 000",

  // Quiz match (step 5)
  "quiz.match.title": "Nous avons votre match !",
  "quiz.match.subtitle": "Indiquez-nous votre adresse e-mail professionnelle pour accéder à votre sélection. Pas de spam, c'est promis !",
  "quiz.match.email_placeholder": "prenom.nom@entreprise.com",
  "quiz.match.cta": "Débloquer mes suggestions",
  "quiz.match.sending": "Envoi en cours...",
  "quiz.email.required": "L'email est requis",
  "quiz.email.invalid": "Adresse e-mail incorrecte",
  "quiz.email.pro": "Veuillez renseigner un email professionnel",

  // Quiz success (step 6)
  "quiz.success.title": "Merci, c'est bien noté !",
  "quiz.success.subtitle": "Vous recevrez prochainement un e-mail avec votre sélection personnalisée. Gardez un œil sur votre boîte de réception !",
  "quiz.success.close": "Fermer",

  // Nav
  "quiz.nav.back": "Retour",
  "quiz.nav.next": "Suivant",
  "quiz.aria.close": "Fermer",
};

const es: Dict = {
  // Header
  "header.discuter": "Conversar",
  "header.discuter_aria": "Conversar con Célia",
  "header.demande_short": "Solicitud",
  "header.envoyer_demande": "Enviar mi solicitud",
  "header.plateforme_short": "Plataforma",
  "header.plateforme_full": "Acceder a la plataforma Bostik - Arkema",
  "header.pill_role": ", su asesora ",

  // Helmet
  "seo.title": "Naboo × Bostik - Arkema — Plataforma de eventos dedicada a los colaboradores de Bostik - Arkema",
  "seo.description": "Plataforma Naboo reservada exclusivamente a los colaboradores de Bostik - Arkema: organice sus seminarios, eventos y team building con condiciones negociadas y un acompañamiento dedicado por Célia.",
  "seo.og.description": "Espacio privado Bostik - Arkema × Naboo: organice sus seminarios y eventos de empresa con tarifas negociadas y acompañamiento dedicado. Reservado para los equipos Bostik - Arkema.",
  "seo.og.image_alt": "Logos Bostik - Arkema y Naboo — Su plataforma de eventos dedicada",
  "seo.twitter.title": "Naboo × Bostik - Arkema — Plataforma de eventos dedicada",
  "seo.twitter.description": "Espacio privado Bostik - Arkema × Naboo: seminarios, eventos y team building con tarifas negociadas y asesora dedicada. Reservado a los colaboradores de Bostik - Arkema.",
  "seo.twitter.image_alt": "Naboo × Bostik - Arkema — Plataforma de eventos dedicada",
  "seo.author": "Naboo para Bostik - Arkema",
  "seo.locale": "es_ES",
  "html.lang": "es",

  // Hero
  "hero.badge": "Quiz",
  "hero.title": "Algunas preguntas rápidas para encontrar su lugar ideal.",
  "hero.step.type": "Tipo de evento",
  "hero.step.dates": "Fechas",
  "hero.step.participants": "Participantes",
  "hero.step.match": "Su selección",
  "hero.cta": "Empezar →",
  "hero.subline": "Obtén resultados en menos de 30seg",

  // Stats
  "stats.partnership_value": "2 años",
  "stats.partnership": "Alianza",
  "stats.events": "Eventos organizados",
  "stats.participants": "Participantes",
  "stats.colleagues": "Colaboradores registrados",

  // Colleagues section
  "colleagues.title": "Ya son 226 los colaboradores de Bostik - Arkema registrados en Naboo",
  "colleagues.paragraph": "Encuentre el historial de sus eventos, el seguimiento de sus proyectos en curso y todos sus presupuestos en un mismo lugar.",
  "colleagues.cta": "Crear una cuenta →",
  "colleagues.label": "Sus colaboradores ya utilizan Naboo",
  "colleagues.more": "colaboradores",

  // Top destinations
  "destinations.title": "Destinos destacados",
  "destinations.instant": "Reserva instantánea",
  "destinations.bottom_title": "Descubra más de 50 000 lugares y proveedores en nuestra base de datos",
  "destinations.bottom_subtitle": "Explore todo el catálogo Naboo reservado a los equipos de Bostik - Arkema.",
  "destinations.bottom_cta": "Explorar los lugares →",

  // Floating push
  "push.line1": "Su lugar ideal en 30s",
  "push.line2": "Quiz Naboo",
  "push.close": "Cerrar",

  // Event types
  "events.title": "Organice cualquier tipo de evento, de 5 a 500 participantes, en cualquier lugar del mundo",
  "events.prev": "Anterior",
  "events.next": "Siguiente",
  "events.go_to": "Ir al evento",
  "events.stay": "Estancia con noche",
  "events.conf": "Conferencias",
  "events.rooms": "Reserva de habitaciones para exposiciones y ferias",
  "events.awayday": "Jornada externa | Reunión | Sesión de formación",
  "events.parties": "Fiestas de empresa | Afterworks",
  "events.meals": "Comidas de negocios | Catering",
  "events.tb": "Actividad de team building",

  // Services
  "services.title": "Una sola plataforma para toda su logística",
  "services.paragraph": "Desde la sala de reuniones hasta el autobús de traslado, nos encargamos de todo. Solo tiene un interlocutor: Célia.",
  "services.catering": "Restauración y catering",
  "services.animation": "Animación y ponentes",
  "services.transport": "Transporte y traslados",
  "services.hotels": "Hoteles y lugares",
  "services.coworking": "Salas y coworking",
  "services.more": "+ cualquier otro servicio de eventos a petición",

  // Preferred terms
  "pt.title": "Benefíciese de condiciones preferentes",
  "pt.col.invoicing": "Gestión de facturas",
  "pt.col.standard": "Servicio Estándar",
  "pt.col.turnkey": "Servicio Llave en Mano",
  "pt.group.admin": "Admin",
  "pt.group.search": "Búsqueda de lugar",
  "pt.group.management": "Gestión de eventos",
  "pt.row.fees": "Tarifas",
  "pt.row.advance": "Anticipo",
  "pt.row.referencing": "Búsqueda y homologación de nuevos espacios y proveedores vía Naboo",
  "pt.row.autonomy": "Autonomía completa en la plataforma",
  "pt.row.delegation": "Delegación del briefing a un experto en eventos con propuestas y soporte ilimitados.",
  "pt.row.assistance": "Asistencia ilimitada para negociar precios y condiciones",
  "pt.row.app": "Aplicación de eventos para organizadores y participantes",
  "pt.row.visit": "Visita al lugar",
  "pt.row.coordination": "Coordinación de los proveedores tras la firma del presupuesto",
  "pt.row.onsite": "Gestor de eventos in situ durante el evento (>40K€)",
  "pt.discover_fees": "Descubra nuestras tarifas",
  "pt.cta": "Descubrir la plataforma Bostik - Arkema",

  // How to
  "how.badge": "En 6 pasos simples",
  "how.title": "¿Cómo funciona?",
  "how.step": "Paso",
  "how.of": "/",
  "how.prev": "Paso anterior",
  "how.next": "Paso siguiente",
  "how.go_to": "Ir al paso",
  "how.s1.title": "Envíe su brief",
  "how.s1.desc": "Envíe su brief a su experto en eventos (vía la plataforma, por email o por teléfono) o busque en total autonomía con la barra de búsqueda.",
  "how.s1.link.platform": "Enlace a la plataforma",
  "how.s2.title": "Obtenga una respuesta rápida",
  "how.s2.desc": "Su experto en eventos responde en una hora, hace las primeras sugerencias en 2 horas y finaliza sus presupuestos en 2 días.",
  "how.s3.title": "Solicite ajustes",
  "how.s3.desc": "Solicite ajustes o nuevas propuestas. Su experto lo actualiza todo en 24 horas hasta que esté listo para confirmar su reserva. Los ajustes son ilimitados.",
  "how.s4.title": "Confirme la reserva",
  "how.s4.desc": "Cuando esté satisfecho con sus presupuestos, descargue el que corresponda a sus expectativas y lance su proceso de orden de compra.",
  "how.s5.title": "Cree su orden de compra",
  "how.s5.desc": "Durante la validación de su orden de compra, haga clic en 'Confirmar la reserva' en la plataforma para descargar la factura final y transformar su orden de compra en pedido. Sin preocupaciones para el pago, Naboo se encarga de todo.",
  "how.s6.title": "Obtenga un soporte completo (opcional)",
  "how.s6.desc": "Si necesita ayuda para organizar su evento, Naboo puede ofrecerle un soporte completo de gestor de eventos hasta el día del evento, ¡solo hay que pedirlo!",

  // Footer
  "footer.terms": "Términos y condiciones de uso",
  "footer.cgu": "CGU",
  "footer.contact": "Contáctenos",
  "footer.cookies": "Modificar sus preferencias de cookies",
  "footer.linkedin": "LinkedIn",
  "footer.instagram": "Instagram",
  "footer.email": "Email",

  // Popover
  "pop.subject": "Solicitud Bostik - Arkema",
  "pop.copy": "Copiar el email",
  "pop.gmail": "Abrir en Gmail",
  "pop.outlook": "Abrir en Outlook",
  "pop.mail_app": "Usar mi aplicación de correo",
  "pop.copied": "Email copiado",
  "pop.copy_error": "Imposible copiar",

  // Lang switcher
  "lang.fr": "FR",
  "lang.es": "ES",

  // Quiz modal
  "quiz.step.type": "Tipo",
  "quiz.step.dates": "Fechas",
  "quiz.step.categories": "Categorías",
  "quiz.step.participants": "Participantes",
  "quiz.step.standing": "Standing",
  "quiz.step.match": "Match",
  "quiz.match_suffix": "% match",
  "quiz.title.type": "¿Qué tipo de evento organiza?",
  "quiz.title.dates_prefix": "¿Cuándo es su ",
  "quiz.title.dates_suffix": "?",
  "quiz.title.event_word": "evento",
  "quiz.title.categories": "¿Qué ambiente busca?",
  "quiz.title.participants": "¿Cuántos participantes?",
  "quiz.title.standing": "¿Cuál es su presupuesto?",
  "quiz.label.0": "Paso 1/6 — ¡Empezamos!",
  "quiz.label.1": "Paso 2/6 — ¡Va por buen camino!",
  "quiz.label.2": "Paso 3/6 — ¡Avanzamos bien!",
  "quiz.label.3": "Paso 4/6 — ¡Solo 2 pasos más!",
  "quiz.label.4": "Paso 5/6 — ¡Ya casi está!",
  "quiz.label.5": "Paso 6/6 — ¡Recta final!",

  "quiz.evt.seminaire": "Seminario de empresa",
  "quiz.evt.journee_hors_site": "Jornada externa",
  "quiz.evt.soiree": "Fiesta de empresa",
  "quiz.evt.team_building": "Actividad de team building",
  "quiz.evt.conference": "Conferencia",
  "quiz.evt.lancement_produit": "Lanzamiento de producto",
  "quiz.evt.autre": "Otro",
  "quiz.evt.placeholder": "Su evento…",

  "quiz.dates.placeholder": "Elegir una fecha",
  "quiz.dates.or_month": "O elija un mes",
  "quiz.month.0": "Enero",
  "quiz.month.1": "Febrero",
  "quiz.month.2": "Marzo",
  "quiz.month.3": "Abril",
  "quiz.month.4": "Mayo",
  "quiz.month.5": "Junio",
  "quiz.month.6": "Julio",
  "quiz.month.7": "Agosto",
  "quiz.month.8": "Septiembre",
  "quiz.month.9": "Octubre",
  "quiz.month.10": "Noviembre",
  "quiz.month.11": "Diciembre",

  "quiz.cat.Plage": "Playa",
  "quiz.cat.Montagne": "Montaña",
  "quiz.cat.Ville": "Ciudad",
  "quiz.cat.Nature": "Naturaleza",
  "quiz.cat.Désert": "Desierto",
  "quiz.cat.Tropical": "Tropical",
  "quiz.cat.Bord de lac": "Orilla del lago",
  "quiz.cat.Île": "Isla",
  "quiz.cat.Historique": "Histórico",
  "quiz.cat.Luxe": "Lujo",
  "quiz.cat.Aventure": "Aventura",
  "quiz.cat.Bien-être": "Bienestar",

  "quiz.tier.Petit comité": "Comité reducido",
  "quiz.tier.Groupe convivial": "Grupo cercano",
  "quiz.tier.Grande équipe": "Gran equipo",
  "quiz.tier.Grand événement": "Gran evento",
  "quiz.tier.Événement XL": "Evento XL",
  "quiz.participants.hint": "Número de participantes",
  "quiz.participants.placeholder": "Ej: 45",

  "quiz.standing.Essentiel": "Esencial",
  "quiz.standing.Confort": "Confort",
  "quiz.standing.Premium": "Premium",
  "quiz.standing.Prestige": "Prestigio",
  "quiz.standing.Exception": "Excepción",

  "quiz.budget.per_person": "es decir {p} € por persona",
  "quiz.budget.or": "O",
  "quiz.budget.exact": "Indicar un importe exacto",
  "quiz.budget.placeholder": "Ej: 25 000",

  "quiz.match.title": "¡Tenemos su match!",
  "quiz.match.subtitle": "Indíquenos su correo profesional para acceder a su selección. Sin spam, ¡prometido!",
  "quiz.match.email_placeholder": "nombre.apellido@empresa.com",
  "quiz.match.cta": "Desbloquear mis sugerencias",
  "quiz.match.sending": "Enviando…",
  "quiz.email.required": "Email requerido",
  "quiz.email.invalid": "Email inválido",
  "quiz.email.pro": "Por favor, use su email profesional",

  "quiz.success.title": "¡Gracias, tomamos nota!",
  "quiz.success.subtitle": "Recibirá próximamente un email con su selección personalizada. ¡Esté atento a su bandeja de entrada!",
  "quiz.success.close": "Cerrar",

  "quiz.nav.back": "Atrás",
  "quiz.nav.next": "Siguiente",
  "quiz.aria.close": "Cerrar",
};

const dicts: Record<Lang, Dict> = { fr, es };

export function detectLang(pathname: string): Lang {
  if (pathname.startsWith("/es")) return "es";
  return "fr";
}

export function useArkemaLang() {
  const { pathname, search } = useLocation();
  const lang = detectLang(pathname);
  const t = (key: string): string => dicts[lang][key] ?? dicts.fr[key] ?? key;
  const switchPath = (target: Lang): string => `/${target}${search || ""}`;
  return { lang, t, switchPath };
}

export function getT(lang: Lang) {
  return (key: string): string => dicts[lang][key] ?? dicts.fr[key] ?? key;
}
